//import 'v-tooltip/dist/v-tooltip.css'
import {
  MethodsEcampus,
  MethodsAuth,
  GenericComputed
} from "@/state/helpers"; 

import moment from "moment";
const apigeneric = {
  data() {
    return {

    }
  },
  methods: {
    ...MethodsEcampus,
    ...MethodsAuth,
    ...GenericComputed,
    ChangePage(event,Sonsayfa) { 
      console.log("event",event)
      if (event.target.innerHTML) {
        if(event.target.innerHTML == "»"){
          this.Page.PageNumber = Math.floor(Sonsayfa)
        }
        else if(event.target.innerHTML == "«"){
          this.Page.PageNumber = 1
        }
        else if(event.target.innerHTML == "‹"){
          this.Page.PageNumber -= 1
        }
        else if(event.target.innerHTML == "›"){
          this.Page.PageNumber += 1
        }
        else{ 
          this.Page.PageNumber = event.target.innerHTML
        }
        this.Get();
      }
    }, 
    formatDateTable(date) {
      return String(moment(String(date)).format("DD.MM.YYYY")); 
    },
    formatDateTableTime(date) {
      return moment(String(date)).add(3, 'hours').format("DD.MM.YYYY HH:mm");
    },
    formatDate(date) {
      return String(moment(String(date)).format("DD-MM-YYYY")); 
    }, 
    formatDb(date) {
      return String(moment(String(date)).format("YYYY-MM-DD")); 
    }, 
    TrParaFormat(value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    OncelikRenklendirme(Oncelik) {
      if (Oncelik === "Kritik") return "bg-kritik";
      if (Oncelik === "Yüksek") return "bg-yuksek";
      if (Oncelik === "Orta") return "bg-orta";
      if (Oncelik === "Düşük") return "bg-dusuk";
    },
    DurumRenklendirme(Durum) {
      if (Durum === "Yeni Oluşturuldu") return "bg-yeni";
      if (Durum === "İade Edildi") return "bg-iade";
      if (Durum === "İlgili Birime Sevk Edildi") return "bg-sevk-birim";
      if (Durum === "İşlemde") return "bg-islemde";
      if (Durum === "İncelemeye ihtiyaç var") return "bg-inceleme";
      if (Durum === "Geçersiz Talep") return "bg-gecersiz";
      if (Durum === "Tamamlandı") return "bg-tamamlandi";
      if (Durum === "Atanan Personel İşlemleri Tamamladı") return "bg-atanan-personel";
      if (Durum === "Atanan Birim İşlemleri Tamamladı") return "bg-atanan-birim";
      if (Durum === "İlgili Personele Sevk Edildi") return "bg-sevk-personel";
    }
    
    

  },
  computed: {
    ...GenericComputed
  },
  created() {
    this.Get();
  },
  mounted() {
    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },
  filters: { 
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },    
    TimeformatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    formatDateTable(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
    formatDateTableTime(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
    formatDateTime(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY HH:DD");
      }
    },
    formatDateTime2(value) { if (value) { return moment(value).format("DD.MM.YYYY HH:mm"); } },
    formatLongDate(value) {
      if (value) {
        var tarih = new Date(value);

        var bolunecek = moment(String(value)).format("DD.MM.YYYY.HH:DD");

        var tarihParcala = bolunecek.split(".");
        var gun = tarihParcala[0];
        var ay = tarihParcala[1] - 1; //ay verisi 0-11 arasında oldugu için bir eksiği alınır.
        var yil = tarihParcala[2];
        var saat = tarihParcala[3];

        var gunler = ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"];
        var aylar = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
        var hangiGundeyiz = tarih.getDay();

        return gun + " " + aylar[ay] + " " + yil + " " + gunler[hangiGundeyiz] + " günü, Saat :" + saat;

      }
    },
    formatNoktaToVirgul(value) {
      if (value) {
        return value.split('.').join(',');
      } else {
        return ""
      }
    },

    BindeAyiraci(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    TrParaFormat(value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }

  },

}

export default apigeneric
